document.addEventListener('DOMContentLoaded', async () => {
    const ratesSearchEls = document.querySelectorAll(".ratessearch");

    if (ratesSearchEls.length > 0) {
        try {
            // Dynamic import loads script only on pages with .ratessearch element
            const { RatesSearch } = await import('./kapitirates.js');

            ratesSearchEls.forEach((ratesSearchEl) => {
                const search = new RatesSearch(ratesSearchEl);
                search.init();
            });
        } catch (error) {
            console.error('Failed to load RatesSearch module:', error);
        }
    }
});